import {Suspense, lazy, useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../_metronic/partials'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {Registration} from '../modules/auth/components/Registration'

export function PrivateRoutes() {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const InsurancePage = lazy(() => import('../modules/insurance/InsurancePage'))
  const CertificatePage = lazy(() => import('../modules/certificate/CertificatePage'))
  const QrCodePage = lazy(() => import('../modules/qr-code/QrCodePage'))
  const PartnerPage = lazy(() => import('../modules/Partners/PartnerPage'))
  const PaymentPage = lazy(() => import('../modules/payments/PaymentPage'))
  const ManageMasterPage = lazy(() => import('../modules/manage-master/ManageMasterPage'))
  const BancassurancePage = lazy(() => import('../modules/Bancassurance/BancassurancePage'))
  const ReportPage = lazy(() => import('../modules/report/reportPage'))
  const RenewablePage = lazy(() => import('../modules/renew/renewPage'))
  const StatisticPage = lazy(() => import('../modules/statistic/statisticPage'))
  const ShortLinkPage = lazy(() => import('../modules/short-link/shortLinkPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const PaymentCallbackPage = lazy(() => import('../modules/payment-callback/PaymentCallbackPage'))
  
  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path='/dashboard' component={DashboardWrapper} />
        <Route path='/crafted/pages/profile' component={ProfilePage} />
        <Route path='/crafted/pages/wizards' component={WizardsPage} />
        <Route path='/crafted/widgets' component={WidgetsPage} />
        <Route path='/crafted/insurance' component={InsurancePage} />
        <Route path='/crafted/certificate' component={CertificatePage} />
        <Route path='/crafted/Bancassurance' component={BancassurancePage} />
        <Route path='/crafted/qr-code' component={QrCodePage} />
        {/* <Route path='/payment' component={PaymentCallbackPage} /> */}
        <Route path='/crafted/partners' component={PartnerPage} />
        <Route path='/crafted/payments' component={PaymentPage} />
        <Route path='/crafted/manage' component={ManageMasterPage} />
        <Route path='/crafted/report' component={ReportPage} />
        <Route path='/crafted/renew' component={RenewablePage} />
        <Route path='/crafted/statistic' component={StatisticPage} />
        <Route path='/crafted/short-link' component={ShortLinkPage} />
        <Route path='/crafted/account' component={AccountPage} />
        <Route path='/apps/chat' component={ChatPage} />
        <Route path='/menu-test' component={MenuTestPage} />
        <Redirect from='/auth' to='/dashboard' />
        <Redirect exact from='/' to='/dashboard' />
        <Redirect to='/error/404' />
      </Switch>
    </Suspense>
  )
}
